<template>
  <div
    class="col-md-6 timesheet-range"
    :class="rangeClass"
    :style="{ width: `${width}%` }"
  >
    <div
      v-if="progressMode"
      class="progress-format"
    >
      <div class="progress">
        <div
          v-tooltip="!!tooltip"
          class="progress-bar w-full"
          :title="tooltip"
          role="progressbar"
        />
      </div>
      <span class="descr text-grey small is-block"><slot /></span>
    </div>
    <div
      v-else
      class="block-format panel panel-default mb-10 p-10"
    >
      <span class="is-bold is-block">{{ title }}</span>
      <span class="descr text-grey is-block"><slot /></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimesheetRange',
  props: {
    title: {
      type: String,
      required: true,
    },
    time_descr: {
      type: String,
      default: '',
    },
    rangeClass: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 100, // percentage
    },
    tooltip: {
      type: String,
      default: '',
    },
    progressMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
